shadow$provide[292] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, binary:{enumerable:true, get:function() {
  return binary;
}}, clamp:{enumerable:true, get:function() {
  return clamp;
}}, cosine:{enumerable:true, get:function() {
  return cosine;
}}, hold:{enumerable:true, get:function() {
  return hold;
}}});
function clamp(x, a, b) {
  return Math.max(a, Math.min(b, x));
}
function cosine(x) {
  return 0.5 - 0.5 * Math.cos(clamp(x, 0, 1) * Math.PI);
}
function binary(x) {
  return +(x >= 0.5);
}
function hold(x) {
  return +(x >= 1);
}

};